import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pagePool'
})
export class PagePoolPipe implements PipeTransform {

    transform(total: number, current: number): any {
        const ret: number[] = [];
        let min: number = current - 4;
        let max: number = current + 3;
        if (min < 0) {
            min = 0;
        }
        if (max > total) {
            max = total;
        }
        for (let i = min; i < max; i += 1)
            ret.push(i);
        return ret;
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/pagination/page-pool.pipe.ts